import PropTypes from 'prop-types';
import React from 'react';
import {TickerInfoEditor, TickerTextEditor} from '..';
import {TICKER_DEFAULTS} from '../../constants/config';
import Box from '../layout/Box';
import Button from '../widgets/Button';
import './styles.scss';

class TickerAddView extends React.Component {
  static propTypes = {
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {...TICKER_DEFAULTS};
  }

  getTickerStyle() {
    const {font_family, font_size, colour, outline, background} = this.state;

    return {
      fontFamily: font_family,
      fontSize: `${font_size  }pt`,
      color: colour,
      textShadow: outline ? `-1px -1px 0 ${outline}, 1px -1px 0 ${outline},-1px 1px 0 ${outline}, 1px 1px 0 ${outline}`
        : null,
      backgroundColor: background,
    };
  }

  handleInfoChange = (newVal) => this.setState(newVal);

  handleSave = () => this.props.onSave(this.state);

  handleTextChange = (newText) => this.setState({text: newText});

  render() {
    return (
      <Box direction="column" className="ticker-add-view">
        <TickerTextEditor text={this.state.text}
                          onChange={this.handleTextChange}
                          tickerStyle={this.getTickerStyle()}
                          isEditing/>
        <TickerInfoEditor ticker={this.state} onChange={this.handleInfoChange}/>
        <Box direction="row" justifyContent="flex-end" className="actions button-group">
          <Button onClick={this.handleSave}>Save</Button>
          <Button onClick={this.props.onCancel} secondary>Cancel</Button>
        </Box>
      </Box>
    );
  }
}

export default TickerAddView;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/TickerAddView/index.js